export const IS_EMAIL_JUST_VERIFIED = 'isEmailJustVerified';

export type ServiceSignUpQueries = {
    [IS_EMAIL_JUST_VERIFIED]: undefined;
};

export type ServiceSignUpQueriesResponseType = {
    [IS_EMAIL_JUST_VERIFIED]: boolean;
};
